import React, { useEffect, useState } from "react";



const IntroPartnerPage: React.FC = () => {
 
  return (
    <div
      className="items-start  w-full h-full "
     
    >
      <div className="flex flex-col gap-y-[12px] md:w-[542px] items-start md:pt-[30px] md:pb-[40px]">
      <div className="common-title">Hi Partner!
      </div>
      <div className="common-sub-text">Glad to see you're interested to partner with some amazing brands and
explore lucrative growth opportunities with us.
</div>

      </div>
    
    </div>
  );
};

export default IntroPartnerPage;
